import { useElemContext } from "../../Contexts/ElemContext";
import SearchBar from "../SearchBar";
import AddButton from "./AddButton";
import SideBarBatch from "./SideBarBatch";
import SideBarElem from "./SideBarElem";

export default function DesktopSideBar({
  pathname,
  filteredGroups,
  filteredExaminers,
}) {
  const { search, setSearch } = useElemContext();

  return (
    <div className="fixed top-[20vh] left-0 h-[80vh] lg:w-[20vw] sm:w-[30vw] bg-primary-yellow border overflow-y-scroll">
      <div className="flex border-2 border-black p-1  bg-primary-yellow w-full ">
        <SearchBar search={search} setSearch={setSearch} />
        <AddButton pathname={pathname} />
      </div>
      <div className="top-[4rem]">
        {pathname === "/student" &&
          filteredGroups.map((group) => (
            <SideBarBatch
              key={group.id}
              content={group.name}
              list={group.students}
            />
          ))}

        {pathname === "/examiner" &&
          filteredExaminers.map((examiner) => (
            <SideBarElem
              key={examiner.id}
              content={examiner}
              contentType="examiner"
            />
          ))}
      </div>
    </div>
  );
}
